import React from 'react'

function BtnGradient({ children}: any) {
   return (
         <div className="w-fit rounded-lg bg-gradient-to-r from-accent-green  to-kyzzen-blue p-0.5 cursor-pointer" >
            <div className="flex h-full w-fit items-center justify-center  bg-kyzzen-primary rounded-lg back">
               {children}
            </div>
         </div>

   )
}

export default BtnGradient
// via-accent-main